import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Input.module.scss';

function Input(props) {
  const { value, setErrorInput, form, innerRef, name = '', type = 'text', placeholder = '', validate = [] } = props;

  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleChange = (event) => {
    props.onChange(event);
    checkErrors(event.target.value);
  };

  const checkErrors = (value) => {
    const hasError = validate.some((validator) => {
      const result = validator(value, form);
      if (result.isError) {
        setIsError(true);
        setErrorMessage(result.message);
      }

      // break (return true) if doesn't pass validation
      return result.isError;
    });

    if (!hasError) {
      setIsError(false);
    }
  };

  return (
    <div
      className={cn(
        styles.wrapper_input,
        isError || setErrorInput ? 'ic-warning' : '',
        props.marginTop ? styles.marginTop : '',
        props.marginBottom ? styles.marginBottom : '',
        props.fullWidth ? styles.fullWidth : '',
      )}
    >
      <input
        name={name}
        type={type}
        value={value}
        ref={innerRef}
        disabled={props.disabled}
        placeholder={isError && value === '' ? errorMessage : placeholder}
        onChange={handleChange}
        onBlur={props.blur ? handleChange : null}
        className={cn(
          styles.input,
          isError || setErrorInput ? styles.error : '',
          props.disabled ? styles.disabled : '',
        )}
        autoComplete={props.autocomplete}
        data-testid={props.testId || 'input-input'}
      />
    </div>
  );
}

export default Input;

Input.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  blur: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  validate: PropTypes.arrayOf(PropTypes.func),
  marginTop: PropTypes.bool,
  marginBottom: PropTypes.bool,
  setErrorInput: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  autocomplete: PropTypes.string,
};
